/* eslint-disable no-unused-vars */
import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import { InformationDialog } from "../../../components/DialogCollection";
import { priceDecimal } from "../../../utils/utilities";

const Preview = (props) => {
  const { data, redemptionDana, onPreview } = props;
  const navigate = useNavigate();
  const {
    bank_code: code,
    bank_account_name: name,
    bank_account_number: accountNumber,
    bank_name: bankName,
    amount,
    reward_id: rewardId,
    point,
  } = data;
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const RenderContent = (datas) => {
    const { label, value } = datas.datas;

    return (
      <div className="mt-3">
        <label className="font-bold">{label}</label>
        <div>
          {label === "Amount" ? "Rp " : ""}
          {priceDecimal(value)}
          {label === "Amount" ? ` (${priceDecimal(point)} pts deduction)` : ""}
        </div>
      </div>
    );
  };

  const onSubmit = () => {
    const formData = {
      reward: rewardId,
      user_data: {
        bank_code: code,
        bank_account_number: accountNumber,
      },
    };

    setIsLoading(true);

    redemptionDana(formData).then((response) => {
      if (response.status === 200) {
        setIsOpen(!isOpen);
      } else {
        toast.error(response.message[0], {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
      setIsLoading(false);
    });
  };

  return (
    <div>
      <Container className="mt-3">
        <div className="py-3">Please check your bank account details:</div>
        <RenderContent datas={{ label: "Bank Name", value: bankName }} />
        <RenderContent
          datas={{ label: "Account Number", value: accountNumber }}
        />
        <RenderContent datas={{ label: "Account Name", value: name }} />
        <RenderContent datas={{ label: "Amount", value: amount }} />
      </Container>
      <div>
        <Button
          variant="danger"
          className="btn-change border-0 mt-4"
          onClick={onSubmit}
          disabled={isLoading}
        >
          Confirm
        </Button>

        <Button
          variant="outline-danger"
          className="w-100 border-0 mt-2"
          onClick={() => onPreview(false)}
        >
          Back
        </Button>
      </div>
      <InformationDialog
        title="Successful"
        style={{ width: "300px" }}
        message="
          You have cashed out this reward to your bank account successfully.
          <br>
          <br>
          Transfer is in progress. Please wait for approximately 15 minutes. You will get an update from notification.
        "
        closeLabel="Done"
        show={isOpen}
        onHide={() => {
          navigate("/reward/voucher/cash-transfer");
          setIsOpen(!isOpen);
        }}
      />
    </div>
  );
};

const mapStateToProps = (_state) => ({});

const mapDispatchToProps = (dispatch) => ({
  redemptionDana: dispatch.RedeemSM.redemptionDana,
});

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
